import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getPetitionGuidesPageData } from './api';
import type { PetitionGuidesPageDataErrorCode } from './types';

export const {
	Context: PetitionGuidesPageDataContext,
	Provider: PetitionGuidesPageDataContextProvider,
	useContext: usePetitionGuidesPageData,
	useAsyncData: usePetitionGuidesPageDataFromApi,
	prefetchAsyncData: prefetchPetitionGuidesPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PetitionGuidesPageDataContext',
	dataProperty: 'pageData',
	getData: getPetitionGuidesPageData,
	getUniqueId: () => 'petitionGuidesPageData',
	errorHandler: pageDataErrorHandler<PetitionGuidesPageDataErrorCode>(),
});
